/* DON'T EDIT THIS FILE: edit original and run build again */ import { AlycTenantHandler } from "../../../framework/tenant-handlers/alyc-tenant-handler.ts";
import { BaseLineOptions } from "../../../framework/tenant-handlers/base-line-options.ts";
import { balanzLineOptions } from "./balanz-line-options.ts";
import { balanzTenant } from "./code.ts";
import { balanzFullLabel } from "./fullLabel.ts";
import { balanzLabel } from "./label.ts";

class BalanzTenantHandler extends AlycTenantHandler {
  getCode(): string {
    return balanzTenant;
  }

  getPathLabel(): string | null {
    return "balanz-capital";
  }

  getLabel(): string {
    return balanzLabel;
  }

  getFullLabel(): string {
    return balanzFullLabel;
  }

  getNotificationsFrom(): string {
    return "no-responder@matchfin.ar";
  }

  getCuit(): string | null {
    return "30-71063067-0";
  }

  getCnvRegistryId(): string | null {
    return "210";
  }

  getMavAgentId(): number | null {
    return 559;
  }

  getLineOptions(): BaseLineOptions | null {
    return balanzLineOptions;
  }

  supportsRiskMatrix(): boolean {
    return false;
  }

  publishesInMarketplace(): boolean {
    return false;
  }
}

const balanzTenantHandler = new BalanzTenantHandler();

export default balanzTenantHandler;
